export default "__VITE_ASSET__6722ccab__"